import { render } from "./PackageSelection.vue?vue&type=template&id=12658f53&scoped=true"
import script from "./PackageSelection.vue?vue&type=script&lang=js"
export * from "./PackageSelection.vue?vue&type=script&lang=js"

import "./PackageSelection.vue?vue&type=style&index=0&id=12658f53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12658f53"],['__file',"resources/js/components/direct_mail/PackageSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12658f53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12658f53', __exports__)) {
    api.reload('12658f53', __exports__)
  }
  
  module.hot.accept("./PackageSelection.vue?vue&type=template&id=12658f53&scoped=true", () => {
    api.rerender('12658f53', render)
  })

}


export default __exports__